import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "separate-account-withdraw"
};
const _hoisted_2 = {
  class: "toolbox"
};
const _hoisted_3 = {
  class: "wrapper"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "团队", -1);

const _hoisted_5 = {
  class: "wrapper"
};

const _hoisted_6 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("重置");

import { ref, onMounted } from 'vue';
import Axios from '@/request/createAxiosInstalce';
import SupplierWithdraw from './supplier-withdraw.vue';
import UserWithdraw from './supplier-online-withdraw.vue';
export default {
  name: 'index',

  setup(__props) {
    onMounted(() => getSupplierList());
    const supplierId = ref('');
    const supplierList = ref([]);

    function getSupplierList() {
      Axios.get('/admin/split/rule/getLevelOneSupplierList.json').then(res => {
        supplierList.value = res.data.data;
      });
    }

    const tab = ref('1');
    const supplierRef = ref();
    const userRef = ref();

    function search() {
      if (tab.value === '1') {
        supplierRef.value.initTable();
      } else {
        userRef.value.initTable();
      }
    }

    function reset() {
      supplierId.value = '';
      setTimeout(() => search(), 300);
    }

    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_tab_pane = _resolveComponent("el-tab-pane");

      const _component_el_tabs = _resolveComponent("el-tabs");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_el_select, {
        modelValue: supplierId.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => supplierId.value = $event),
        placeholder: "请选择团队",
        style: {
          "width": "300px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "全部",
          value: ""
        }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(supplierList.value, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            label: item.supplierName,
            value: item.supplierId
          }, null, 8, ["label", "value"]);
        }), 256))]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: search
      }, {
        default: _withCtx(() => [_hoisted_6]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: reset
      }, {
        default: _withCtx(() => [_hoisted_7]),
        _: 1
      })])]), _createVNode(_component_el_tabs, {
        modelValue: tab.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => tab.value = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "团队分账提现",
          name: "1"
        }), _createVNode(_component_el_tab_pane, {
          label: "客户账期回款提现",
          name: "2"
        })]),
        _: 1
      }, 8, ["modelValue"]), tab.value === '1' ? (_openBlock(), _createBlock(SupplierWithdraw, {
        key: 0,
        supplierId: supplierId.value,
        ref_key: "supplierRef",
        ref: supplierRef
      }, null, 8, ["supplierId"])) : (_openBlock(), _createBlock(UserWithdraw, {
        key: 1,
        supplierId: supplierId.value,
        ref_key: "userRef",
        ref: userRef
      }, null, 8, ["supplierId"]))]);
    };
  }

};